module.exports = __webpack_public_path__ + "static/media/link-externo.a9fd8d07.svg";